function init_socceranim(from_php){
    if(from_php.girl_id==0){
        return false;
    }
    var anim_conf=$.takeGirlConf(1006,"fight_png"),i,girl_img=$.takeGirlImage(1006);
    var main=$(".place.socceranim");
    main.find("#gameNeed,#girlAnim,#lickAnim").addClass("hide");
    function initDialog(){
        var book=main.find("#gameNeed");
        book.removeClass("hide");

        var suit_have_obj={"12":from_php.goalkeeper.suit_id};

        var girlObj=new girlSuitView(from_php.goalkeeper.girl_id,suit_have_obj);
        girlObj.makeView(book.find(".girlWrap[data-type='soccer'] .img"));

        suit_have_obj={"12":from_php.need_suit[from_php.girl_id]};
        girlObj=new girlSuitView(from_php.girl_id,suit_have_obj)

        girlObj.makeView(book.find(".girlWrap[data-type='own'] .img"));
        main.find(".btnBigPink:not(.backbtn)").show();
    }

    function initLickAnim() {
        main.find(".fakelayPromoBig").show();
        main.find(".fakelayPromo").hide();
        var animIndexQueue=_moduleTimeHandler.getNewIndex();
        for(i in anim_conf){
            anim_conf[i]={"path":_IMG_SERV+"/gfx/place/fight/animation/"+girl_img+"/"+i+"/anim.png","conf":anim_conf[i]};
        }
        var qcanv=main.find("#lickAnim").show().removeClass("hide");;
        qcanv =qcanv.find(".canvMain");
        qcanv.off("was_loaded").one("was_loaded",function(){
            qcanv.animCircle("addSteps",[{howlong:4000,"end_val":0}]);
            _moduleTimeHandler.set(animIndexQueue,function(){
                if(qcanv.animCircle("howlongRemain")<5000) {
                    qcanv.animCircle("addSteps", [{howlong: 4000, "end_val": 0}]);
                }
                if (intval(qcanv.attr("cumshot")) === 1) {
                    qcanv.animCircle("setSteps", [{howlong: 500, "end_val": 0}, {howlong: -1, "end_val": "end"}]);
                    _moduleTimeHandler.clear(animIndexQueue);
                }
            },3000);
            qcanv.animCircle("start")

        }).animCircle({},anim_conf,_moduleTimeHandler);
        main.find("#cumButton").off().one("click",function () {
            $(this).animate({opacity:0},1000);
            qcanv.attr("cumshot",1);
        });
    }

    function initAnim(){
        var anim_name=_mySound.playSound("girl_play");
        _moduleEvents.on("moduleClear",function(){
            _mySound.stopSound(anim_name);
        });

        var book=main.find("#girlAnim");
        book.removeClass("hide");
        main.find(".fakelayPromo").removeClass("scale");

        var anim_conf={
            "1":{width: 482, height: 544, left: 450, top: 120, clips: 10},
            "2":{width: 454, height: 599, left: 300, top: 150, clips: 10},
            "3":{width: 597, height: 476, left: 100, top: 315, clips: 9},
            "4":{width: 609, height: 416, left: 300, top: 240, clips: 10},
            "5":{width: 595, height: 493, left: 250, top: 260, clips: 10},
            "6":{width: 680, height: 468, left: 120, top: 350, clips: 10},
            "7":{width: 456, height: 652, left: 340, top: 70, clips: 10},
            "8":{width: 574, height: 564, left: 200, top: 170, clips: 11},
            "9":{width: 524, height: 423, left: 260, top: 310, clips: 10},
            "10":{width: 504, height: 378, left: 400, top: 400, clips: 10}
        };

//        anim_conf[from_php.anim_id].left=200;
//        anim_conf[from_php.anim_id].top=780-anim_conf[from_php.anim_id].height-30;

        var imagesObj={
            "1":{
                conf:{period_min:50,period_max:100},
                arr:[
                    {
                        path:_IMG_SERV+"/gfx/place/socceranim/anim/"+from_php.anim_id+".png",
                        conf:anim_conf[from_php.anim_id]
                    }
                ]
            }
        };

        var qcanv=main.find(".canvWrap .canvMain");
        qcanv.off("was_loaded").one("was_loaded",function(){
            qcanv.animCircleLoop("start");

        }).animCircleLoop({},imagesObj,_moduleTimeHandler);

        main.find(".backbtn").show().css({left:"75%",bottom:50});
    }
    if(from_php.set_ready){
        var ready = intval(from_php.set_ready);
        console.log(ready);
        if(ready === 1) {
            initAnim();
        }
        if(ready === 2) {
            initLickAnim();
        }

    }
    else{
        initDialog();
    }

    var canv=main.find("#canvMain");

    canv.one("was_loaded",function(){
        var indexCard=_moduleTimeHandler.getNewIndex();
        var imgArr=["red","blue","green","white","yellow"];
        function addAnim(){
            var pos_start,pos_end,img_name,step_max;
            img_name=imgArr[mt_rand(0,4)];
            step_max=mt_rand(100,200);
            pos_start=[mt_rand(0,1280),0];
            pos_end=[pos_start[0]+mt_rand(-100,100),850];
            canv.startGirlAnim("addAnimClipCustom",pos_start,pos_end,img_name,step_max,10,mt_rand(30,70));
        }
        function qLoop(){
            var howlong=mt_rand(350,750);
            _moduleTimeHandler.setOne(indexCard,function(){
                addAnim();
                qLoop();
            },howlong);
        }
        qLoop();


        // addAnimClipCustom:function(start_point,end_point,img_arr,step_max,clip_period){

//            afterLoadObj.load();
    }).startGirlAnim({
        load_images:{
            "red":""+_IMG_SERV+"/gfx/place/socceranim/cards/red.png",
            "blue":""+_IMG_SERV+"/gfx/place/socceranim/cards/blue.png",
            "green":""+_IMG_SERV+"/gfx/place/socceranim/cards/green.png",
            "white":""+_IMG_SERV+"/gfx/place/socceranim/cards/white.png",
            "yellow":""+_IMG_SERV+"/gfx/place/socceranim/cards/yellow.png"
        }
    },_moduleTimeHandler);


    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });

}